export default "__VITE_ASSET__CeRT3DrM__"